import React from "react";

const Header = () => {
    return (
        <div className="d-flex justify-content-between align-items-center p-4">
            <h2 className="font-24 font-weight-s-bold m-0">Account Manager Monthly Report</h2>
        </div>
    );
};

export default Header;
